/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from 'react'
import PropTypes from 'prop-types'
import {ThemeProvider} from 'emotion-theming'
import styled from '@emotion/styled'

import theme from '../theme'
import GlobalStyled from './GlobalStyles'
import TopBar from './TopBar'
import Footer from './Footer'
import Seo from './Seo'
import {HighlightOverlayProvider} from './HighlightOverlay'
import {CurrentLocationProvider} from '../utils/CurrentLocation'

const RootContainer = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 100vh;
`

const ChildrenContainer = styled.div`
	flex: 1;
	padding-top: ${props => props.noTopSpace ? '0' : '11rem'};
`

const Layout = ({children, noTopSpace, darkTopBar, seo, footerBack}) => <ThemeProvider theme={theme}>
	<CurrentLocationProvider value={seo.routeUrl}>
		<HighlightOverlayProvider>
			<GlobalStyled/>
			<Seo routeUrl='/404' {...seo}/>
			<RootContainer>
				<TopBar dark={darkTopBar}/>
				<ChildrenContainer noTopSpace={noTopSpace}>{children}</ChildrenContainer>
				<Footer underColor={footerBack === 'gray' ? theme.colors.grayBack : 'white'}/>
			</RootContainer>
		</HighlightOverlayProvider>
	</CurrentLocationProvider>
</ThemeProvider>

Layout.propTypes = {
	children: PropTypes.node.isRequired,
	footerBack: PropTypes.oneOf('white', 'gray'),
	darkTopBar: PropTypes.bool,
	noTopSpace: PropTypes.bool,
	seo: PropTypes.shape({
		routeUrl: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		description: PropTypes.string.isRequired,
		metaImage: PropTypes.shape({
			publicURL: PropTypes.string.isRequired,
		}),
	}).isRequired,

}

Layout.defaultProps = {
	darkTopBar: false,
	footerBack: 'white',
	noTopSpace: false,
}

export default Layout
